export default __webpack_public_path__ + "static/media/hamburgericon.4ced3f90.svg";